import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { TimeAnimSection } from '../../timeAnimSection';

export function ExtraBetsHeader({ handleShowExtraBets }) {
  const t = useTranslation();
  return (
    <div className='extra-bet-header'>
      <div className='extra-bet-head-left-cont'>
        <TimeAnimSection isInExtra />
      </div>
      <div className='extra-bet-head-middle-cont'>
        <p className='extra-bet-title'>{t('EXTRA_BETS')}</p>
      </div>
      <div className='extra-bet-head-right-cont' onClick={handleShowExtraBets}>
        <i className='icon-close extra-bet-header-icon' />
      </div>
    </div>
  );
}
